import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { createQueryClient } from '@wp-one/api'
import { handleUnauthorized, useSession } from '@wp-one/auth'
import { ToastProvider } from '@wp-one/ui'
import { FerozWidget } from '@wp-one/feroz'
import '@wp-one/ui/styles.css'
import '@wp-one/feroz/feroz.css'
import './app/app.css'
import { router } from './app/router'
import { getRuntimeConfig } from './app/config'
import { startMonitoring } from './app/monitoring'

void startMonitoring(getRuntimeConfig())

// any 401 anywhere = session gone → ProtectedModule sends to /conta/entrar with the reason
const queryClient = createQueryClient({
  onError: (error) => handleUnauthorized(queryClient, error),
})

/** Feroz só para quem está logado (nunca no login/páginas públicas). useSession
 * devolve null em 401, então não aparece sem sessão. */
function FerozLogado() {
  const { data: user } = useSession()
  return user ? <FerozWidget /> : null
}

const root = document.getElementById('root')
if (!root) throw new Error('Elemento #root não encontrado')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
        {/* Feroz não faz parte da entrega principal (ver front/CLAUDE.md). Opt-in explícito, não
            `import.meta.env.DEV`: o `telas.sh` roda o Playwright contra `vite dev` de propósito
            (pro /vitrine funcionar), então DEV=true também lá — um widget sempre visível
            apareceria em toda screenshot de referência e reprovaria o PR de qualquer módulo.
            Pra ver localmente: `VITE_FEROZ_DEV_WIDGET=1 pnpm dev`. Só aparece para quem está
            logado — nunca no login nem em páginas públicas (decisão do Lucas, 26/10/2026). */}
        {import.meta.env.VITE_FEROZ_DEV_WIDGET === '1' && <FerozLogado />}
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
